import { CHILD_WELL_INFO, CHILD_WELL_INFO_ERROR, CHILD_WELL_INFO_SUCCESS, CROSS_WELL_BULK_UPDATE, CROSS_WELL_BULK_UPDATE_ERROR, CROSS_WELL_BULK_UPDATE_SUCCESS, CROSS_WELL_CORDINATES_DATA, CROSS_WELL_CORDINATES_DATA_ERROR, CROSS_WELL_CORDINATES_DATA_SUCCESS, DAS_SOCKET_DATA, DTS_SOCKET_DATA, PARENT_WELL_INFO, PARENT_WELL_INFO_ERROR, PARENT_WELL_INFO_SUCCESS } from './constants';

export default function crossWellReducer(state, action) {
	switch (action.type) {
	case PARENT_WELL_INFO:
		return {...state, loading : true, error : false };
	case PARENT_WELL_INFO_SUCCESS :
		return {...state, parentWellData : action?.payload?.data, loading :false, error : false};
	case PARENT_WELL_INFO_ERROR:
		return {...state, loading : false, error : true };

	case CHILD_WELL_INFO:
		return {...state, loading : true, error : false };
	case CHILD_WELL_INFO_SUCCESS :
		return {...state, childWellData : action?.payload?.data, loading :false, error : false};
	case CHILD_WELL_INFO_ERROR:
		return {...state, loading : false, error : true };

	case DTS_SOCKET_DATA : 	
		return { ...state, dtsData: action.payload };
	
	case DAS_SOCKET_DATA : 	
		return { ...state, dasData: action.payload };

	case CROSS_WELL_CORDINATES_DATA:
		return {...state, loading : true, error : false };
	case CROSS_WELL_CORDINATES_DATA_SUCCESS :
		return {...state, crossWellCrodinatesData : action?.payload?.data, loading :false, error : false};
	case CROSS_WELL_CORDINATES_DATA_ERROR:
		return {...state, loading : false, error : true };

	case CROSS_WELL_BULK_UPDATE:
		return {...state, loading : true, error : false };
	case CROSS_WELL_BULK_UPDATE_SUCCESS :
		return {...state, loading :false, error : false};
	case CROSS_WELL_BULK_UPDATE_ERROR:
		return {...state, loading : false, error : true };
			
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}